import { ButtonSiguiente } from "@/components/ui";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const PopupAfiliado: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="absolute top-4 left-4">
        <ButtonSiguiente
          onClick={() => navigate("/backoffice")}
          className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 shadow"
        >
          ⬅ Volver
        </ButtonSiguiente>
      </div>

      <div className="bg-zinc-400 text-zinc-700 w-full max-w-3xl p-6 rounded-xl shadow-md border-zinc-600 border-r-4 border-t-2 flex flex-col gap-6 shadow-orange-700">
        <h2 className="text-2xl font-bold text-center">
          Gestión de Afiliados
        </h2>

        <div className="grid grid-cols-12 gap-4">
          <button
            onClick={() => navigate("/crearAfiliado")}
            className="col-span-12 sm:col-span-6 bg-green-600 text-white p-4 rounded-lg border-r-4 border-b-2 hover:bg-green-700 transition"
          >
            Crear Afiliado
          </button>

          <button
            onClick={() => navigate("/editarAfiliado")}
            className="col-span-12 sm:col-span-6 bg-yellow-500 text-white p-4 rounded-lg border-r-4 border-b-2 hover:bg-yellow-600 transition"
          >
            Editar Afiliado
          </button>

          <button
            onClick={() => navigate("/bajaAfiliado")}
            className="col-span-12 sm:col-span-6 bg-red-600 text-white p-4 rounded-lg border-r-4 border-b-2 hover:bg-red-700 transition"
          >
            Dar de Baja/Activar
          </button>

          <button
            onClick={() => navigate("/resumenAfiliado")}
            className="col-span-12 sm:col-span-6 bg-blue-600 text-white p-4 rounded-lg border-r-4 border-b-2 hover:bg-blue-700 transition"
          >
            Ver Resumen
          </button>

          <button
            onClick={() => navigate("/promocionesGenerales")}
            className="col-span-12 bg-purple-700 text-white p-4 rounded-lg border-r-4 border-b-2 hover:bg-purple-800 transition"
          >
            Gestionar Promociones Generales
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupAfiliado;
